import { render } from "./TeamPointsCard.vue?vue&type=template&id=76f390aa&scoped=true"
import script from "./TeamPointsCard.vue?vue&type=script&lang=js"
export * from "./TeamPointsCard.vue?vue&type=script&lang=js"

import "./TeamPointsCard.vue?vue&type=style&index=0&id=76f390aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f390aa"]])

export default __exports__